module.exports = __webpack_public_path__ + "static/media/passo-2.88f8272c.gif";